import {auth} from './firebase.js'

export default (to, from, next) => {
  auth.onAuthStateChanged((user) => {
    if (user) {
      next()
    } else {
      next('/login')
    }
  })
}
